var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Local/Button/01-Small/02-Icon/03-Utility") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit---Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Local/Button/01-Small/02-Icon/03-Utility"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u269B\\uFE0F-Atoms-/-Background-/-01-Rounded-Medium"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Border",
    stroke: "#B85C00",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u269B\\uFE0F-Atoms-/-Icons-/-02-Small-/-Pin",
    transform: "translate(4.000000, 4.000000)",
    fill: "#B85C00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M12,10 C11.4477153,10 11,10.4477153 11,11 L11,16 C11,16.5522847 11.4477153,17 12,17 C12.5522847,17 13,16.5522847 13,16 L13,11 C13,10.4477153 12.5522847,10 12,10 Z M12,7 C11.4477153,7 11,7.44771525 11,8 C11,8.55228475 11.4477153,9 12,9 C12.5522847,9 13,8.55228475 13,8 C13,7.44771525 12.5522847,7 12,7 Z",
    id: "Icons"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPhoto);
export default __webpack_public_path__ + "static/media/info_photo.199242cff18908131b9a335c8beb7c65.svg";
export { ForwardRef as ReactComponent };